import { groupBy } from "lodash";
export var orderCategories = function() {
    var categories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], az = arguments.length > 1 ? arguments[1] : void 0, za = arguments.length > 2 ? arguments[2] : void 0;
    if (az || za) {
        return categories.sort(function(a, b) {
            var aName = (a.name || "").toLowerCase();
            var bName = (b.name || "").toLowerCase();
            var sortDir = az ? -1 : 1;
            if (aName < bName) return sortDir;
            if (aName > bName) return -sortDir;
            return 0;
        });
    }
    return categories.sort(function(a, b) {
        return (Number(a.pos) || 0) - (Number(b.pos) || 0);
    });
};
export var dedupeCategories = function(categories) {
    return Object.values(groupBy(categories, "id")).map(function(sameCats) {
        return(// As of 191108, bundles don't include the parent category name
        // So make sure to keep the category that has a parentName
        sameCats.find(function(cat) {
            return cat.parentName;
        }) || sameCats[0]);
    });
};
